import React, { useState } from 'react'

import checkmarkBg from '@frame/images/checkmark-bg.svg'
import { Transition } from '@headlessui/react'

export function AnimatedCheckmark({ show }: { show: boolean }) {
  const [showNext, setShowNext] = useState(false)

  return (
    <div className="relative flex items-center justify-center">
      <Transition
        as="div"
        show={show}
        enter="transition-all duration-500"
        enterFrom="opacity-0 rotate-[180deg] scale-0"
        enterTo="opacity-100 rotate-0 scale-100"
        leave="transition-opacity duration-300"
        leaveFrom="opacity-100 rotate-0 scale-100"
        leaveTo="opacity-0 rotate-[180deg] scale-0"
        className="relative flex h-6 w-6 items-center justify-center"
        afterEnter={() => setShowNext(true)}
      >
        <img src={checkmarkBg} />
        {showNext && <DrawingAnimation />}
      </Transition>
    </div>
  )
}

function DrawingAnimation() {
  return (
    <svg viewBox="0 0 13 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="animate-fill absolute w-[13px]">
      <defs>
        <clipPath id="clip">
          <rect id="clip-rect" x="0" y="0" width="12" height="10" />
        </clipPath>
      </defs>
      <path
        d="M7.73733 8.30629L12.4027 3.68713C13.1765 2.92097 13.1765 1.68013 12.4027 0.913974C11.6289 0.147816 10.3756 0.147816 9.6018 0.913974L5.12987 5.34159C5.03174 5.43875 4.87473 5.43875 4.77941 5.34159L3.5654 4.13961C2.78596 3.3679 1.52429 3.3679 0.747661 4.13961C-0.0317724 4.91132 -0.0317724 6.16049 0.747661 6.92942L2.13831 8.30629C3.68315 9.83583 6.19248 9.83583 7.73733 8.30629Z"
        className="fill-path"
        clipPath="url(#clip)"
      />
    </svg>
  )
}
